import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Image from "next/image";
import { ArrowLeftIcon, ArrowRightIcon } from "lucide-react";
import { BASE_ASSETS_URL } from "@constants/constants";

const testimonials = [
  {
    companyLogo: `${BASE_ASSETS_URL}/v2/clm/clm/testimonial-slider-eye-care-1.png`,
    quote:
      "BoloSign helped us streamline our caregiver agreements. What used to take hours is now done in minutes, and everything is HIPAA-compliant.",
    avatar: `${BASE_ASSETS_URL}/v2/clm/clm/testimonial-slider-rachel.png`,
    name: "Rachel Monroe",
    title: "Director of Operations at Eye Care",
  },
  {
    companyLogo: `${BASE_ASSETS_URL}/v2/clm/clm/testimonial-slider-bena-vest-1.png`,
    quote:
      "We handle hundreds of client policies across health and retirement. BoloSign lets us streamline compliance paperwork and maintain a clear signing history for every client interaction.",
    avatar: `${BASE_ASSETS_URL}/v2/clm/clm/testimonial-slider-jonathan.png`,
    name: "Jonathan Ellis",
    title: "Head of Compliance at BenaVest",
  },
  {
    companyLogo: `${BASE_ASSETS_URL}/v2/clm/clm/testimonial-slider-overstock-1.png`,
    quote:
      "We've scaled to 30+ locations. Without BoloSign, keeping track of sales agreements, warranty policies, and franchise contracts would've been a nightmare.",
    avatar: `${BASE_ASSETS_URL}/v2/clm/clm/testimonial-slider-greg.png`,
    name: "Greg Thomas",
    title: "VP of Retail Operations at Overstock Furniture & Mattress",
  },
];

const TestimonialSlider = () => {
  const transition = { duration: 0.5, ease: "easeInOut" };

  const [currentIndex, setCurrentIndex] = useState(0);

  const variants = {
    enter: { y: 20, opacity: 0 },
    center: { y: 0, opacity: 1 },
    exit: { y: 25, opacity: 0 },
  };

  return (
    <div className="px-8  max-w-screen-xl xl:mx-auto">
      <section className="bg-cream rounded-3xl py-4 mx-4 md:mx-10 px-4 md:py-20 md:px-32 xl:px-48 my-12 shadow-sm transition-all duration-400 max-w-screen-xl xl:mx-auto">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentIndex}
            initial="enter"
            animate="center"
            exit="exit"
            variants={variants}
            transition={transition}
          >
            {/* Logo */}
            <div className="mb-4">
              <Image
                // src={`${BASE_ASSETS_URL}/v2/clm/clm/circularise.svg")}
                src={testimonials[currentIndex].companyLogo}
                alt="Company Logo"
                width={200}
                height={200}
              />
            </div>

            {/* Quote */}
            <p className="text-2xl text-gray-900 mb-6">
              “{testimonials[currentIndex].quote}”
            </p>

            {/* Avatar + Name */}
            <div className="flex items-center justify-left gap-4">
              <Image
                src={testimonials[currentIndex].avatar}
                alt={testimonials[currentIndex].name}
                width={50}
                height={50}
                className="rounded-lg object-cover"
              />
              <div className="text-sm">
                <p className="font-semibold text-gray-900">
                  {testimonials[currentIndex].name}
                </p>
                <p className="text-gray-600">
                  {testimonials[currentIndex].title}
                </p>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>

        {/* Arrows */}
        {/* when the button is disabled it should be dull in color */}
        {/* when the button is enabled it should be bright in color */}
        <div className="flex justify-end mt-6 gap-4">
          <button
            onClick={() => setCurrentIndex((i) => i - 1)}
            disabled={currentIndex === 0}
          >
            <ArrowLeftIcon
              className={
                currentIndex === 0
                  ? "w-6 h-6 text-blue-200"
                  : "w-6 h-6 text-blue-600"
              }
            />
          </button>
          <button
            onClick={() => setCurrentIndex((i) => i + 1)}
            disabled={currentIndex === testimonials.length - 1}
          >
            <ArrowRightIcon
              className={
                currentIndex === testimonials.length - 1
                  ? "w-6 h-6 text-blue-200"
                  : "w-6 h-6 text-blue-600"
              }
            />
          </button>
        </div>
      </section>
    </div>
  );
};

export default TestimonialSlider;
